exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hover-redirect {\n  z-index: 20;\n  position: absolute;\n  left: 2px;\n  top: 2px;\n}\n", ""]);

// exports
